import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "./guards/auth.guard";
import { ErreurComponent } from "./shared/components/erreur/erreur.component";
import { NotFirstLoginGuard } from "./guards/not-first-login.guard";
import {AdminCtfPartyComponent} from "./core/admin/components/admin-ctf-party/admin-ctf-party.component";

const routes: Routes = [
    {
        path: "",
        loadChildren: () => import("./core/hub/hub.module").then((m) => m.HubModule),
        canActivate: [AuthGuard, NotFirstLoginGuard],
    },
    {
        path: "challenges",
        loadChildren: () => import("./core/challenges/challenges.module").then((m) => m.ChallengesModule),
        canActivate: [AuthGuard],
    },
    { path: "erreur/:status", component: ErreurComponent },
    { path: "**", redirectTo: "erreur/404" },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: "enabled",
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule {}
